/**
 * KiaanTabs — the top tab row of the widget.
 *
 * SUN-70 (Manak, 2026-10-20): ✦ Agents · Communications · Calendar & meetings · System monitor (admins)
 * · Dev mode (admins). Everyone else gets 🐞 Report a bug last, as before.
 * Admin-only buttons are not rendered at all when the flag is false — the DOM must hold no
 * trace of them for a non-admin (Review Focus 1).
 */
export type KiaanTabKey = 'agents' | 'comms' | 'calendar' | 'system' | 'dev' | 'bug';

export const TAB_KEYS: KiaanTabKey[] = ['agents', 'comms', 'calendar', 'system', 'dev', 'bug'];

export interface KiaanTabsProps {
  active: KiaanTabKey;
  devMode: boolean;
  reportBug: boolean;
  /** System monitor (SUN-69): admins only — not rendered at all otherwise. */
  systemMonitor?: boolean;
  onChange: (tab: KiaanTabKey) => void;
}

export function KiaanTabs({ active, devMode, reportBug, systemMonitor = false, onChange }: KiaanTabsProps) {
  const tab = (key: KiaanTabKey, label: string) => (
    <button
      key={key}
      type="button"
      role="tab"
      aria-selected={active === key}
      className={`kw-tab${active === key ? ' kw-on' : ''}`}
      onClick={() => onChange(key)}
    >
      {label}
    </button>
  );
  return (
    <div className="kw-tabs" role="tablist" aria-label="Kiaan" data-tour="kiaan-tabs">
      {tab('agents', '✦ Agents')}
      {tab('comms', 'Communications')}
      {tab('calendar', 'Calendar & meetings')}
      {systemMonitor && tab('system', 'System monitor')}
      {devMode ? tab('dev', 'Dev mode') : reportBug ? tab('bug', '🐞 Report a bug') : null}
    </div>
  );
}
